import React from 'react';

const ChipIndicator = () => {
    return (
        <div className="tw-w-[103px] tw-h-[22px] tw-px-2 tw-py-1 tw-bg-emerald-500 tw-rounded tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
            <div className="tw-text-white tw-text-xs tw-font-medium">Recommended</div>
        </div>
    );
}

export default ChipIndicator;